export default "__VITE_ASSET__bba795fa__"